export const HANDLE_NAVIGATION = "HANDLE_NAVIGATION"
export const SET_LANG = "SET_LANG"